<template>
	<div>
		<headerTag />
		<div class="errorDiv wrapper">
			<div class="notFound" style="margin-top: 2rem;">
				<img src="../../assets/images/user/sorry.png" alt="" /></br>
				<img src="../../assets/images/user/nofound2.png" alt="" /></br>
				<p style="font-size: 1.1rem;">
					对不起，由于此浏览器兼容问题，烦请您添加</br>零分享QQ顾问或拨打电话，继续咨询！
				</p>
			</div>
			<div class="errorKefu">
				<div>
					<p>
						<img src="../../assets/images/detail/QQ.png" alt=""/>
						<span id="copyValue">{{qqNum}}</span>
						<button @click="copy" data-agl-cvt="32" id="copyTxt" data-clipboard-action="copy" data-clipboard-target="#copyValue">点击复制</button>
					</p>
					<p>
						<img src="../../assets/images/detail/phone.png" alt=""/>
						<span>15918923845</span>
						<a href="tel:15918923845"><button style="background: #F99F2A;">立即拨打</button></a>
					</p>
				</div>
			</div>
		</div>
	</div>
	

</template>


<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import Clipboard from 'clipboard'
	
    export default {
    	name: 'qqTans',
    	data(){
			return{
				qqNum:'',
			}
		},
		methods:{
			copy(){
				var clipboard = new Clipboard('#copyTxt', {
				    text: function () {
				        //return $('#copyValue').text();
				    }
				});
						
				clipboard.on('success', e => {  
					this.$message.success({message: '已复制成功，快去QQ添加好友吧~~'});
					// 释放内存  
					clipboard.destroy()  
				})  
				clipboard.on('error', e => {  
					  // 不支持复制 
					   this.$message.error({message: '抱歉哦，复制失败请手动复制QQ~~'});
					  // 释放内存  
					  clipboard.destroy()  
				})  
				       
			},
		},
    	components: {
    		headerTag,
    	},
		mounted(){
			
			this.qqNum = this.$route.query.sqq;
		}
    }
</script>


